import Btn from '../Btn'
import CreateUserDlg from '../CreateUserDlg'
import EditUserDlg from '../EditUserDlg'
import AddCircleIcon from '@mui/icons-material/AddCircle'

import {
  TableContainer, Table, TableBody, TableRow, TableCell,
  Typography, Box, Link, useMediaQuery
} from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import Loader from '../Loader/Loader'
import { useGetUsersMutation, useDeleteUserMutation } from '../../redux/api/usersApi'
import { type IUser, type IUserProfile } from '../../redux/api/types'
import { openCreateDlg, setCreateUserErrorMessage } from '../../redux/features/createUserDlgSlice'
import { openEditDialog, setEditUserErrorMessage, setEditUserEmail, setEditUserFirstName, setEditUserSecondName, setEditUserId } from '../../redux/features/editUserDlgSlice'
import ErrorMessage from '../ErrorMessage'
import useToken from '../../hooks/useToken'

const shapeStyles = { width: 30, height: 30 }
const shapeCircleStyles = { color: '#FFF', fontSize: '15px', borderRadius: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }

const RoundedTableRow = styled(TableRow)(({ theme }) => ({
  '& td': {
    backgroundColor: '#FFF',
    borderTop: '5px solid #F7F8FA',
    borderBottom: '5px solid #F7F8FA'
  },
  '& td:first-child': {
    backgroundColor: '#FFF',
    borderLeft: '0px solid #F7F8FA',
    borderTop: '5px solid #F7F8FA',
    borderBottom: '5px solid #F7F8FA',
    borderRadius: '15px 0 0 15px'
  },
  '& td:last-child': {
    backgroundColor: '#FFF',
    borderRight: '0px solid #F7F8FA',
    borderTop: '5px solid #F7F8FA',
    borderBottom: '5px solid #F7F8FA',
    borderRadius: '0 15px 15px 0'
  }
}))

const ThinTableCell = styled(TableCell)(({ theme }) => ({
  paddingTop: 15,
  paddingBottom: 15,
  paddingLeft: 0,
  paddingRight: 0
}))

const RecentLeads: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const dispatch = useDispatch()
  const handleOpenCreateDialog = () => {
    dispatch(setCreateUserErrorMessage(''))
    dispatch(openCreateDlg())
  }

  const [getUsers, { data: getUsersData, isLoading: isGetUsersLoading }] = useGetUsersMutation()

  const createDlg = useSelector((state: any) => state.createUserDlgState)
  const editDlg = useSelector((state: any) => state.editUserDlgState)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  const [deleteUser, { error: deleteUsersError, isError: isDeleteUserError, isLoading: isDeleteUserLoading }] = useDeleteUserMutation()

  useEffect(() => {
    getUsers().then().catch(e => {})
  }, [createDlg.openCreateDialog, editDlg.openEditDialog, isDeleteUserLoading])

  const {
    xsrf,
    isLoading: isLoadingXSRF
  } = useToken()

  return (
    <>
    <Box>
      <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', mb: 2 }}>
        <Typography sx={{ flexGrow: 1, fontSize: 16, fontWeight: 900, lineHeight: '20px', color: '#7D8FB3' }}>All Users</Typography>
        <Btn
          variant='outlined'
          color='secondary'
          text='Add New'
          onClick={handleOpenCreateDialog}
          startIcon={
            <AddCircleIcon/>
          }
          sx={{ py: 1, px: 4 }}/>
      </Box>
        {isDeleteUserError
          ? <Box sx={{ mb: 2 }}>
              <ErrorMessage error={deleteUsersError}/>
            </Box>
          : null
        }
        {isGetUsersLoading || isLoadingXSRF || isDeleteUserLoading
          ? <Box sx={{ marginTop: 20 }}><Loader /></Box>
          : <TableContainer sx={{ borderCollapse: 'separate' }}>
        <Table sx={{ width: '100%', borderCollapse: 'separate' }} aria-label="Monthly Activity">
          <TableBody>
          {getUsersData?.map((row: IUser) => (
            <RoundedTableRow
              key={row.id}
            >
              <ThinTableCell sx={{ px: isMobile ? 1 : 3, maxWidth: '40px' }}>
                {/* <Box sx={{ ...shapeStyles, ...shapeCircleStyles, bgcolor: `${row.color}` }}> */}
                <Box sx={{ ...shapeStyles, ...shapeCircleStyles, bgcolor: 'PeachPuff' }}>
                  {row.firstName[0]}
                </Box>
              </ThinTableCell>
              { isMobile
                ? (
                    <ThinTableCell sx={{ pr: 1, color: '#7D8FB3', fontSize: 13 }}>
                      <Box>{row.firstName} {row.secondName}</Box>
                      <Box>{row.email}</Box>
                    </ThinTableCell>
                  )
                : (
                    <>
                      <ThinTableCell sx={{ pr: 2, minWidth: '50px', maxWidth: '70px', color: '#7D8FB3' }}>{row.firstName} {row.secondName}</ThinTableCell>
                      <ThinTableCell sx={{ pr: 2, minWidth: '150px', color: '#7D8FB3' }}>{row.email}</ThinTableCell>
                    </>
                  )
              }

              {row.isAccountOwner
                ? <ThinTableCell align="right" sx={{ color: '#C3CAD9', pr: isMobile ? '4px' : 2 }}>
                    Account Owner
              </ThinTableCell>
                : <>
                  {user.isAccountOwner
                    ? <ThinTableCell align="right" sx={{ color: '#7D8FB3x', pr: isMobile ? '4px' : 2 }}>
                <Link
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    dispatch(setEditUserErrorMessage(''))
                    dispatch(setEditUserEmail(row.email))
                    dispatch(setEditUserFirstName(row.firstName))
                    dispatch(setEditUserSecondName(row.secondName))
                    dispatch(setEditUserId(row.id))
                    dispatch(openEditDialog())
                  }}
                  sx={{ mr: isMobile ? '10px' : 3 }}>Edit</Link>
                <Link onClick={(e: React.MouseEvent<HTMLElement>) => {
                  deleteUser({ id: row.id, token: xsrf }).then().catch(e => {})
                }}>Delete</Link>
              </ThinTableCell>
                    : <ThinTableCell />}
                  </>}

            </RoundedTableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>}
    </Box>
    <EditUserDlg/>
    <CreateUserDlg/>
    </>
  )
}

export default RecentLeads
